export default "/fonts/parisienne-regular-webfont.woff?e0f295c7394eec1d224d43b9ab9765fe";